<template>
    <HomeLayoutBack customClass="max-w-1140px">
        <BackButtonDesktop @clickBack="clickBack()"></BackButtonDesktop>
        <div class="border-b border-a-brown-e1d2bc pb-10" v-if="campaign != null">
            <div class="grid grid-cols-1 lg:grid-cols-10 gap-4 lg:gap-8 mt-6" >
                <div class="lg:col-span-6 px-4 lg:px-0">
                    <Picture :campaign="campaign"></Picture>
                    <div class="block lg:hidden text-16 font-bold text-a-brown-502314 mt-3">{{campaign.name}}</div>
                    
                </div>
                <div class="box-detail lg:col-span-4 border-0 lg:border border-a-brown-d7c7b8 rounded-20 p-0 lg:p-6 relative">
                    <div class="px-4 lg:px-0">
                        <div class="bg-a-brown-e7d7c1 p-3 rounded-10" v-if="subScriptPackage && isPackage">
                            <div >Package Information <span v-if="subScriptPackage.AllowCancel">(Recurring Package)</span></div>
                            <div class="flex justify-between">
                                <div class="mt-2 flex">
                                    <div>
                                        <img class="mr-2 mt-0.5" src="@/assets/shopping_cart/Calendar.png" />
                                    </div>
                                    <div>
                                        <div class="text-14 text-a-brown-502314 ">Expire Date : {{FilterDateFormat(subScriptPackage.ExpireDate)}}</div>
                                        <div class="text-14 text-a-brown-502314 " v-if="subScriptPackage.SecondExpireDate">
                                            Expire Date : {{FilterDateFormat(subScriptPackage.SecondExpireDate)}}
                                        </div>
                                    </div>
                                </div>
                                <div class="cursor-auto mt-auto my-0 text-14 underline text-a-brown-9f8273" v-if="subScriptPackage.AllowCancel" @click="clickCancel()">Cancel package?</div>
                            </div>
                        </div>
                    </div>
                    
                    <DetailAndCondition v-if="isLoadedPackage" :campaign="campaign" :subScriptPackage="subScriptPackage"></DetailAndCondition>
                    <div class="hidden lg:block w-full absolute bottom-0 left-0 p-6" v-if="!isNotiDetail">
                        <div class="text-center text-16 text-a-brown-502314" v-if="isTypeBuy()">
                            {{FilterNumberFormat(campaign.pricePerUnit)}} {{ lbl.campaign.baht }}
                        </div>
                        <div class="flex items-center justify-center" v-else>
                            <div class="mr-2"><img class="w-7" src="../../../../assets/icon/crown-brown.svg"></div>
                            <div class="text-16 text-a-brown-502314">
                                Use {{FilterNumberFormat(campaign.pointPerUnit)}} Crown Points
                            </div>
                        </div>
                        <div v-if="isLoginGuest" class="text-12 text-a-red-d14545 text-center mt-3">{{lbl.detail.warnning_guest_1}} <span class="underline cursor-pointer" @click="clickLogin()">{{lbl.detail.warnning_guest_2}}</span></div>
                        <div class="max-w-xs m-auto mt-2" v-if="isPackage && isLoadedPackage">
                            <RedButton v-if="subScriptPackage && subScriptPackage.AllowRenew"
                                    @click="clickRenewal()">
                                Renewal Package
                            </RedButton>
                            <DisableBtn v-else>Renewal Package</DisableBtn>
                            <button @click="clickViewRewards()"
                                class="mt-2 py-2.5 px-2 w-full lg:text-18  font-bold rounded-full border border-a-red-d62300 bg-white text-a-red-d62300">
                                View Rewards
                            </button>
                        </div>
                        <div class="max-w-xs m-auto" v-if="!isPackage && isLoadedPackage">
                            <RedeemButton
                                    class="mt-2"
                                    :detailController="detailController"
                                    :subScriptPackage="subScriptPackage"
                                    @clickRedeem="clickRedeem()"
                            ></RedeemButton>
                        </div>
                    </div>
                    <div class="hidden lg:block w-full absolute bottom-0 left-0 p-6" v-else>
                        <RedButton @click="clickRedeemNoti()">
                            <div>{{ lbl.redeem_button.reward_noti }}</div>
                        </RedButton>
                    </div>
                </div>
            </div>
            <div class="hidden lg:block text-24 font-bold text-a-brown-502314 mt-6">{{campaign.name}}</div>
        </div>
        <CampaignRelate
                v-if="campaignRelate.length > 0 && !isNotiDetail"
                :campaignList="campaignRelate"
        ></CampaignRelate>
        <FooterButtonMobile
                v-if="campaign != null && !isNotiDetail && !isPackage && isLoadedPackage"
                :detailController="detailController"
                :subScriptPackage="subScriptPackage"
                @clickRedeem="clickRedeem()"
        ></FooterButtonMobile>
        <NotiFooterButtonMobile
                v-if="campaign != null  && isNotiDetail"
                :detailController="detailController"
                @clickRedeem="clickRedeem()"
        ></NotiFooterButtonMobile>
        <PackageFooterButtonMobile
                v-if="campaign != null && isPackage && isLoadedPackage && subScriptPackage != null"
                :detailController="detailController"
                :subScriptPackage="subScriptPackage"
                @clickRedeem="clickRedeem()"
                @clickRenewal="clickRenewal()"
                @clickViewRewards="clickViewRewards()"
        ></PackageFooterButtonMobile>
    </HomeLayoutBack>
</template>
<script>

//helper
import Util from '@/helper/Utility.js';
import ConfigManager from '@/config/ConfigManager.js';
import CacheHelper from '@/helper/CacheHelper.js';
//component
import HomeLayoutBack from '@/components/Layout/Page/HomeLayoutBack.vue'
import BackButtonDesktop from '@/components/Button/BackButtonDesktop.vue'
import Picture from '../component/Picture.vue';
import DetailAndCondition from '../component/DetailAndCondition.vue';
import RedeemButton from '../component/RedeemButton.vue';
import CampaignRelate from '../component/CampaignRelate/CampaignRelate.vue';
import FooterButtonMobile from '../component/FooterButtonMobile.vue';
import NotiFooterButtonMobile from '../component/NotiFooterButtonMobile.vue';
import PackageFooterButtonMobile from '../component/PackageFooterButtonMobile.vue';
import RedButton from '@/components/Button/RedButton.vue'
import DisableBtn from '@/components/Button/DisableBtn.vue';
//mixin
import ModalMixin from '@/mixin/ModalMixin.js';
import AuthStatusMixin from '@/mixin/AuthStatusMixin.js';
import LocaleMixin from "@/mixin/LocaleMixin.js";
//controller
import { DetailController } from '../controller/DetailController.js';
import { RedeemController } from '../controller/RedeemController.js';
//service
import { CampaignConfigBuilder } from '@/core/Campaign/model/CampaignConfigModel.js';
import { CampaignType } from "@/helper/StaticValue.js";

import BKSubscription from '@/module/Subscription/List/service/BKSubscription';

export default {
    mixins: [ModalMixin, AuthStatusMixin, LocaleMixin],
    components: {
        HomeLayoutBack,
        BackButtonDesktop,
        Picture,
        DetailAndCondition,
        RedeemButton,
        CampaignRelate,
        FooterButtonMobile,
        NotiFooterButtonMobile,
        PackageFooterButtonMobile,
        RedButton,
        DisableBtn,
    },
    data: function() {
        return {
            isLoaded: false,
            //controller
            detailController: new DetailController(),
            redeemController: new RedeemController(),

            campaign: null,
            campaignRelate: [],
            isNotiDetail: false,
            isPackage: false,
            subScriptPackage: null,
            isLoadedPackage: false,

        };
    },
    mounted: function () {
        Util.scrollTop();

    },
    methods: {
        //#region mixin
        /**
         * ฟังก์ชันนี้ถูกเรียก หลังจากตรวจสอบได้แล้วว่า login แล้วหรือยัง
         */
        onAccountInit: async function () {
            this.initialCampaign();
            this.isNotiDetail = this.$route.name == 'noti_detail' ? true : false;
            this.isPackage = this.$route.name == 'package_detail' ? true : false;
            // if (this.isPackage) {
            //     await this.getPackagesItem();
            //     this.isLoadedPackage = true;
            // }
        },
        /**
         * ฟังก์ชันนี้ถูกเรียก หลักจาก setup generic model เรียบร้อย
         */
        onSetupModalCompleted: function() {
            this.initialRedeemModal(); //ModalMixin
            this.initialAddressModal(); //ModalMixin
        },
        //#endregion mixin

        //#region initial
        initialCampaign: function () {
            this.campaign = null;
            var campaignId = this.$route.params.campaignId;
            this.campaignConfig = new CampaignConfigBuilder()
                .setCampaignId(campaignId)
                .setWithRelate(true)
                .create();

            this.setupDetailController();
        },

        /**
         * Function หลังจากหลับมาจากเว็บ Interface ให้ clear browser history
         */
        initialIsFromLanding: function () {
            var cacheHelper = new CacheHelper(ConfigManager.getCacheType());
            var formLanding = Util.jsonParse(cacheHelper.getCache('isfromlanding'));

            if (formLanding != null) {
                cacheHelper.removeCache('isfromlanding');

                if (formLanding.page == 'wodd') {
                    return;
                }
                var backAmount = (formLanding.page == 'interface') ? -3 : -2;
                history.go(backAmount);
            }
        },
        //#endregion initial

        //#region setup
        setupDetailController: function() {
            this.modal.loadingModal.show();
            this.detailController.initial(this.campaignConfig).then((campaign) => {
                Util.log("campaign", campaign);
                this.campaign = campaign;
                this.campaignRelate = campaign.related;

                this.redeemController.initial(this.campaign, this.modal);
                this.setRedeemEvent();
                this.onLoadedCampaign();
            }).catch((err) => {
                this.errorApi(err);
            }).finally(() => {
                this.modal.loadingModal.hide();
            });
        },
        //#endregion setup
        clickRedeemNoti: function () {
            this.$router.push("/mycoupon");
        },
        //#region event
        clickRedeem: function() {
            if (this.isTypeBuy()) {
                this.$router.push("/subscriptionpayment/" + this.campaign.id);
            } else {
                this.tracking.event('rewards','clik_get_coupon', `${this.campaign.id}|${this.campaign.name}`);
                var selectCampaignId = this.detailController.selectedCampaignId;
                var selectedQuantity = this.detailController.selectedQuantity;
                this.redeemController.clickRedeem(selectCampaignId, selectedQuantity);
            }
            
        },
        setRedeemEvent: function() {
            this.redeemController.onClickRedeem = () => {
                return true;
            };
            this.redeemController.onConfirmRedeem = () => {
                this.tracking.event('rewards','click_confirm_to_redeem', `${this.campaign.id}|${this.campaign.name}`);
                return true;
            };
            this.redeemController.onCancelRedeem = () => {
                return true;
            };
            this.redeemController.onOpenInterface = () => {
                return true;
            };
            this.redeemController.onOpenShipping = () => {
                return true;
            };
            this.redeemController.onSaveShipping = () => {
                return true;
            };
            this.redeemController.onRedeem = () => {
                this.modal.loadingModal.show();
                return true;
            };
            this.redeemController.onRedeemSuccess = (info) => {
                this.modal.loadingModal.hide();
                this.apiUpdateProfile();
                if (info?.redirect != null) {
                    this.$router.push(info?.redirect);
                } else {
                    this.initialCampaign();
                }
                return true;
            };
            this.redeemController.onRedeemError = () => {
                this.modal.loadingModal.hide();
                return true;
            };
            this.redeemController.onAddToCart = () => {
                this.modal.loadingModal.show();
                return true;
            };
            this.redeemController.onAddToCartSuccess = () => {
                this.modal.loadingModal.hide();
                return true;
            };
            this.redeemController.onAddToCartError = () => {
                this.modal.loadingModal.hide();
                return true;
            };
        },
        //#endregion event

        onLoadedCampaign: async function () {
            if (this.isTypeBuy()) {
                await this.getPackagesItem();
                this.isLoadedPackage = true;
            } else {
                this.isLoadedPackage = true;
            }
        },

        isTypeBuy: function () {
            return this.campaign.type == CampaignType.Buy;
        },

        clickLogin: function () {
            let path = this.$route.path;
            this.$router.push('/login?afterLogin=' + path);
        },
        clickBack: function () {
            this.$router.back();
        },

        clickRenewal: function () {
            this.$router.push("/subscriptionpayment/" + this.campaign.id);
        },
        clickViewRewards: function () {
            this.$router.push("/reward");
        },
        clickCancel: function () {
            this.modal.confirmModal.clearModal()
                    .setMsg(this.lbl.subscription.detail.cancel_subscription_package,)
                    .setRemark(this.lbl.subscription.detail.condition_confirm_package)
                    .setBtnOk(this.lbl.subscription.detail.confirm)
                    .show();
            this.modal.confirmModal.onClickOk( async () => {
                let deleteSuccess = await this.deletePackage();
                if (deleteSuccess) {
                    this.modal.successModal
                        .clearModal()
                        .setMsg(this.lbl.subscription.detail.cancel_package_success)
                        .show();
                    this.modal.successModal.onClose(async () => {
                        this.modal.loadingModal.show();
                        await this.getPackagesItem();
                        this.modal.loadingModal.hide();
                    });
                }
            });
        },
        deletePackage: function () {
            let campaignId = this.$route.params.campaignId;
            return new Promise((resolve) => {
                this.isLoading = true;
                BKSubscription.apiDeletePackage(campaignId).subscribe({
                    next: (res) => {
                        console.log(res.data)
                        resolve(true);
                    },
                    error: (err) => {
                        this.errorApi(err);
                        resolve(false);
                    }
                });
            });
        },
        getPackagesItem: function () {
            let campaignId = this.$route.params.campaignId;
            return new Promise((resolve) => {
                this.isLoading = true;
                BKSubscription.apiGetMyPackagesItem(campaignId).subscribe({
                    next: (res) => {
                        this.subScriptPackage = res.data;
                        resolve();
                    },
                    error: (err) => {
                        console.log(err);
                        // this.errorApi(err);
                        resolve();
                    }
                });
            });
        }
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/base.scss";
    .box-detail {
        @include md-screen() {
            padding-bottom: 117px;
        }
    }
</style>
